import request from '../../utils/request'
const getShortLink = (data) => {
    return request({
        url:  `u/g`,
        method: 'POST',
        data
    })
}
const signatureOss = (data) => {
  return request({
      url:  `mp/fission/oss/signature`,
      method: 'POST',
      data
  })
}
const ossImg = (data,url) => {
  console.log('3123',data,url)
  return request({
      url,
      method: 'POST',
      data
  })
}


export {
  getShortLink,
  signatureOss,
  ossImg
}